/**
 * @author Mark Cremer <mark@firstcoders.co.uk>
 * @author Adrian Judd <AngularJS@AdrianJudd.com>
 */
angular
    .module('satv.search')
    .factory('RecursionHelper', ['$compile', function ($compile) {
        "use strict";
        return {
            /**
             * Manually compiles the element, fixing the recursion loop.
             * @param element
             * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
             * @returns An object containing the linking functions.
             */
            compile: function (element, link) {
                // Normalize the link parameter
                if (angular.isFunction(link)) {
                    link = {post: link};
                }

                // Break the recursion loop by removing the contents
                var contents = element.contents().remove();
                var compiledContents;
                return {
                    pre: (link && link.pre) ? link.pre : null,
                    /**
                     * Compiles and re-adds the contents
                     */
                    post: function (scope, element) {
                        // Compile the contents
                        if (!compiledContents) {
                            compiledContents = $compile(contents);
                        }
                        // Re-add the compiled contents to the element
                        compiledContents(scope, function (clone) {
                            element.append(clone);
                        });

                        // Call the post-linking function, if any
                        if (link && link.post) {
                            link.post.apply(null, arguments);
                        }
                    }
                };
            }
        };
    }])

    .directive('satvFilterTree', ['RecursionHelper', '$compile', 'SearchConfig', function (RecursionHelper, $compile, SearchConfig) {
        return {
            restrict: 'AE',
            scope: {
                title: '=',
                children: '=',
                model: '=',
                count: '=',
                key: '='
            },
            controller: function ($scope, $element) {
                var childElement;
                var childTpl = '<ul class="satv-picklist ">' +
                    '<li ng-repeat="grandchild in children" >' +
                    '<satv-filter-tree model="grandchild" key="key" data-title="grandchild.title" children="grandchild.children" count="grandchild.count">' +
                    '</satv-filter-tree>' +
                    '</li>' +
                    '</ul>';

                $scope.isOpen = false;
                $scope.hasChildren = (angular.isArray($scope.children) && $scope.children.length > 0);
                $scope.isset = SearchConfig.isset($scope.key, parseInt($scope.model.id));

                $scope.toggle = function (e) {
                    e.stopPropagation();
                    if ($scope.hasChildren) {
                        $scope.isOpen = !$scope.isOpen;
                        $scope.iconClassName = $scope.isOpen ? 'fa-chevron-down' : 'fa-chevron-right';

                        if ($scope.isOpen) {
                            childElement = $compile(childTpl)($scope);
                            $element.append(childElement);
                        } else {
                            childElement.remove();
                        }
                    }
                };

                $scope.toggleSelect = function (e, model) {
                    SearchConfig.toggle($scope.key, model.id);
                };

                $scope.toggleSelectMinus = function (e, model) {
                    //remove old - would be nice to have a toggle off
                    var p, i;
                    p = SearchConfig.getArrayProperty($scope.key);
                    if (typeof model.id === 'string' && !isNaN(parseInt(model.id))) {
                        i = p.indexOf(parseInt(model.id));
                    } else {
                        i = p.indexOf(model.id);
                    }
                    if (i != -1) {
                        SearchConfig.toggle($scope.key, model.id);
                    }
                    //apply new negative filter
                    SearchConfig.toggleMeta($scope.key, model.id, model.title);
                    SearchConfig.toggle($scope.key, '-' + model.id);
                };

                if ($scope.hasChildren) {
                    $scope.iconClassName = 'fa-chevron-right';
                }
            },
            template:
            '<div ng-class="{\'active\': isset}" class="filter_tree_element">' +
                '<div class="filter_tree_element_overbox">'    +
                '  <i class="fa fa-minus-circle filter_tree_element_tagline filter_tree_element_overtext" style="color:white" ng-click="toggleSelectMinus($event, model)"></i>' +
                '  <i class="fa fa-plus-circle filter_tree_element_tagline filter_tree_element_overtext" style="color:white" ng-click="toggleSelect($event, model)"></i>' +
                '</div>' +
                '<div class="satv-picklist_a">' +
                    '<span ng-if="hasChildren" class="icon filter_tree_element_underneath title not-accessible" ng-click="toggle($event)"><i class="fa fa-fw [[iconClassName]]"></i></span>' +
                    '<span role="checkbox" aria-checked="[[isset]]" class="filter_tree_element_underneath title not-accessible" ng-click="toggleSelect($event, model)" ><span class="px-2">[[::title]] </span> <span class="badge">[[::count]]</span></span>' +
                '</div>' +
            '</div>'
        };

    }])

    .directive('satvAppliedFilters', ['$compile', 'Search', 'SearchConfig', '$filter', function ($compile, Search, SearchConfig, $filter) {

        var FilterIterator = {
            walkGroups: function (data, groupChildrenKey, filterChildrenKey, callback) {
                angular.forEach(data, function (groupNode) {
                    FilterIterator.walkFilters(groupNode[groupChildrenKey], filterChildrenKey, callback);
                });
            },
            walkFilters: function (children, filterChildrenKey, callback) {
                angular.forEach(children, function (child) {
                    callback(child);
                    if (child.children) {
                        FilterIterator.walkFilters(child[filterChildrenKey], filterChildrenKey, callback);
                    }
                });
            }
        };

        return {
            restrict: 'AE',
            scope: {
                'groupName': '=',
                'key': '=',
                'source': '=',
                'groupChildren': '=',
                'filterChildren': '='
            },
            link: function ($scope, element, attr, ctrl) {
                //var source = $scope.source;
                var loader = Search.getLoader();
                var meta = loader.meta;
                $scope.appliedFilters = [];
                for (var childKey in meta[$scope.$parent.filterGroupName]) {
                    $scope.appliedFilters.push({id: childKey, title: meta[$scope.$parent.filterGroupName][childKey]});
                }

                $scope.removeFilter = function (filter) {
                    SearchConfig.toggle(
                        $scope.key,
                        filter.id
                    );
                };
            },
            template: '<ul class="satv-picklist">' +
            '<li ng-repeat="filter in appliedFilters track by filter.id">' +
            '<a aria-role="checkbox" aria-checked="true" href="javascript:void(0);" ng-click="removeFilter(filter);"><i class="fa fa-times"></i> <span class="screenreader">Remove filter</span> <s ng-if="!(filter.id|plusOrMinus)" data-toggle="tooltip" data-placement="right" data-html="true" title="Filter where tracks do NOT include [[filter.title]]" data-original-title="Filter where tracks do <em>NOT</em> include [[filter.title]]" placement="right">[[filter.title]]</s> <span  ng-if="(filter.id|plusOrMinus)" data-toggle="tooltip" data-placement="right" title="Filter where tracks includes [[filter.title]]" placement="right">[[filter.title]]</span></a>' +
            '</li>' +
            '</ul>'
        };
    }])
;



// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/Resources/js/angular/directives/satvFilterTree.js